import { types } from 'mobx-state-tree';

export default types.model('HttpErrorResponse', {
  status: types.union(types.number, types.string),
  error: '',
});
